export const showOptionsByPark = {
  "Magic Kingdom": [
    {
      name: "Happily Ever After",
      type: "Nighttime Spectacular",
      showStrategyNote: ["Nighttime Spectaculars", "See it All"],
    },
    {
      name: "Mickey's Magical Friendship Faire",
      type: "Stage Show",
      showStrategyNote: ["Stage Shows", "See it All"],
    },
    {
      name: "Mickey’s PhilharMagic",
      type: "Indoor Show",
      showStrategyNote: ["Stage Shows", "See it All"],
    },
    {
      name: "Country Bear Musical Jamboree",
      type: "Stage Show",
      showStrategyNote: ["Stage Shows", "See it All"],
    },
    {
      name: "Disney Festival of Fantasy Parade",
      type: "Parade",
      showStrategyNote: ["Parades", "See it All"],
    },
    {
      name: "Disney Starlight: Dream the Night Away",
      type: "Parade",
      openingNoteKeywords: ["July 20, 2025"],
      showInfoNote: "Debuts July 20, 2025",
      showStrategyNote: ["Parades", "See it All"],
    },
  ],

  EPCOT: [
    {
      name: "Luminous: The Symphony of Us",
      type: "Nighttime Spectacular",
      showStrategyNote: ["Nighttime Spectaculars", "Cultural", "See it All"],
    },
    {
      name: "Voices of Liberty",
      type: "Cultural",
      showStrategyNote: ["Cultural", "Stage Shows", "See it All"],
    },
    {
      name: "The American Adventure",
      type: "Cultural Show",
      showStrategyNote: ["Cultural", "Stage Shows", "See it All"],
    },
    {
      name: "Canada Far and Wide",
      type: "Cultural Show",
      showStrategyNote: ["Cultural", "See it All"],
    },
    {
      name: "Impressions de France",
      type: "Cultural Show",
      showStrategyNote: ["Cultural", "See it All"],
    },
  ],

  "Hollywood Studios": [
    {
      name: "Fantasmic!",
      type: "Nighttime Spectacular",
      showStrategyNote: ["Nighttime Spectaculars", "Stage Shows", "See it All"],
    },
    {
      name: "Beauty and the Beast – Live on Stage",
      type: "Stage Show",
      showStrategyNote: ["Stage Shows", "See it All"],
    },
    {
      name: "Indiana Jones Epic Stunt Spectacular",
      type: "Stage Show",
      showStrategyNote: ["Stage Shows", "See it All"],
    },
    {
      name: "Disney Junior Play & Dance!",
      type: "Family Show",
      showStrategyNote: ["Stage Shows", "Young Children", "See it All"],
    },
    {
      name: "The Little Mermaid - A Musical Adventure",
      type: "Stage Show",
      showStrategyNote: ["Stage Shows", "Young Children", "See it All"],
    },
    {
      name: "For the First Time in Forever: A Frozen Sing-Along Celebration",
      type: "Stage Show",
      showStrategyNote: ["Stage Shows", "Young Children", "See it All"],
    },
  ],

  "Animal Kingdom": [
    {
      name: "Festival of the Lion King",
      type: "Stage Show",
      showStrategyNote: ["Animal & Nature", "Stage Shows", "See it All"],
    },
    {
      name: "Feathered Friends in Flight!",
      type: "Animal & Nature",
      showStrategyNote: ["Animal & Nature", "See it All"],
    },
    {
      name: "Finding Nemo: The Big Blue… and Beyond!",
      type: "Stage Show",
      showStrategyNote: ["Animal & Nature", "Stage Shows", "See it All"],
    },
    {
      name: "It’s Tough to Be a Bug!",
      type: "Indoor Show",
      warningNote: "Temporarily closed for refurbishment",
      closureNoteKeywords: ["March 2025"],
      showStrategyNote: ["Animal & Nature", "See it All"],
    },
  ],
};